import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import icX1 from 'Assets/img/header/ic_x_22.png';
import icX2 from 'Assets/img/header/ic_x_22@2x.png';
import icX3 from 'Assets/img/header/ic_x_22@3x.png';
import { getImageSet } from 'Util/DataUtils';
import icNoty1 from 'Assets/img/header/ic_noty.png';
import icNoty2 from 'Assets/img/header/ic_noty@2x.png';
import icNoty3 from 'Assets/img/header/ic_noty@3x.png';
import IntlMessages from 'Util/IntlMessages';
import Scrollbars from 'react-custom-scrollbars-2';
import { collapsedNotificationSidebarAction } from 'Actions/AppSettingsActions';
import useNotification from './hooks/useNotification';
import useNotificationRoute from './hooks/useNotificationRoute';
import Item from './components/Item';
import { putNotyAll } from 'Api/endpoints/User';
import { useError } from 'Api/hooks/useError';
import useNoty from 'Util/useNoty';

const icX = getImageSet([icX1, icX2, icX3]);
const icNoty = getImageSet([icNoty1, icNoty2, icNoty3]);

const NotificationSidebar = () => {
  const sidebarRef = useRef(null);
  const { notificationCollapsed } = useSelector(state => state.settings);
  const { notifications, infiniteScrollRef, isLastPage } = useNotification();
  const dispatch = useDispatch();
  const { getCategoryData } = useNotificationRoute();
  const scrollRef = useRef(null);
  const { showErrorPopup } = useError();
  const { refreshNoty } = useNoty();

  useEffect(() => {
    const handleClickOutside = event => {
      if (notificationCollapsed) return;
      if (!sidebarRef.current) return;
      const isToggleButton = event.target.closest('[data-notification-toggle="true"]');
      const isClickInsideSidebar = sidebarRef.current.contains(event.target);

      if (!isToggleButton && !isClickInsideSidebar) {
        dispatch(collapsedNotificationSidebarAction(true));
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dispatch, notificationCollapsed]);

  useEffect(() => {
    if (!notificationCollapsed) {
      scrollRef.current.scrollToTop();
    }
  }, [notificationCollapsed]);

  // BroadcastChannel을 통해 다른 창/탭에서 noty refresh 요청 수신
  useEffect(() => {
    const channel = new BroadcastChannel('naya-noty-refresh');

    const handleMessage = event => {
      if (event.data === 'refresh-noty') {
        refreshNoty();
      }
    };

    channel.addEventListener('message', handleMessage);

    return () => {
      channel.removeEventListener('message', handleMessage);
      channel.close();
    };
  }, [refreshNoty]);

  const handleAllRead = async () => {
    try {
      const result = await putNotyAll();
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      refreshNoty();
      dispatch(collapsedNotificationSidebarAction(true));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={`notification-sidebar ${notificationCollapsed && 'collapse'}`} ref={sidebarRef}>
      <div className='notification-sidebar-header'>
        <div className='notification-sidebar-header-title'>
          <img {...icNoty} alt='noty' />
          <span className='notification-sidebar-header-title-text'>
            <IntlMessages id='header.notification.title' />
          </span>
        </div>
        <img {...icX} alt='x' className='cursor-pointer no-drag' onClick={() => dispatch(collapsedNotificationSidebarAction(true))} />
      </div>

      <div className='notification-sidebar-content'>
        <div className='notification-sidebar-content-header'>
          <span className='notification-sidebar-content-header-button cursor-pointer no-drag' onClick={handleAllRead}>
            <IntlMessages id='sidebar.notification.allRead' />
          </span>
        </div>
        <Scrollbars
          className='rct-scroll'
          autoHide
          autoHideDuration={100}
          style={{
            height: 'calc(var(--vh, 1vh) * 100 - 175px)',
          }}
          ref={scrollRef}
        >
          <div className='notification-sidebar-content-list'>
            {notifications.map((item, index) => (
              <Item key={`noty-${index}`} item={item} index={index} getCategoryData={getCategoryData} notifications={notifications} />
            ))}
            {!isLastPage && <div ref={infiniteScrollRef} style={{ height: '10px', width: '100%' }} />}
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

export default NotificationSidebar;
